var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardHeaderConnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 55.5C42.6877 55.5 55 43.1877 55 28C55 12.8122 42.6877 0.5 27.5 0.5C12.3122 0.5 0 12.8122 0 28C0 32.3992 1.03295 36.5569 2.86951 40.2444C3.35758 41.2242 3.52003 42.3443 3.23708 43.4016L1.59915 49.5234C0.888113 52.1808 3.31928 54.6118 5.97671 53.9009L12.0983 52.263C13.1558 51.98 14.2758 52.1425 15.2557 52.6304C18.943 54.4671 23.1008 55.5 27.5 55.5ZM16.5 31.4375C15.3609 31.4375 14.4375 32.361 14.4375 33.5C14.4375 34.639 15.3609 35.5625 16.5 35.5625H31.625C32.764 35.5625 33.6875 34.639 33.6875 33.5C33.6875 32.361 32.764 31.4375 31.625 31.4375H16.5ZM14.4375 23.875C14.4375 22.736 15.3609 21.8125 16.5 21.8125H38.5C39.639 21.8125 40.5625 22.736 40.5625 23.875C40.5625 25.014 39.639 25.9375 38.5 25.9375H16.5C15.3609 25.9375 14.4375 25.014 14.4375 23.875Z",
    fill: "#FF6B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHeaderConnectIcon);
export default __webpack_public_path__ + "static/media/dashboard-header-connect-icon.8eadb2823478b8b4fd7483e0cabf390c.svg";
export { ForwardRef as ReactComponent };